import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import React, { useRef } from 'react';

import { GenerationsTable } from 'components/GenerationsTable';

export function Generations() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout title="Генерации">
      <GenerationsTable
        id="generations-table"
        ref={tableRef}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по ID',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              ...(parseInt(str, 10)
                ? [{ id: { _eq: parseInt(str, 10) } }]
                : []),
            ]),
          }),
        }}
        customFilter={{
          filters: [
            {
              type: 'select',
              name: 'Тип',
              field: 'type',
              items: [
                { value: 'video', text: 'Видео' },
                { value: 'image', text: 'Изображение' },
              ],
            },
            {
              type: 'select',
              name: 'Статус',
              field: 'status',
              items: [
                { value: 'queued', text: 'В очереди' },
                { value: 'running', text: 'Выполняется' },
                { value: 'completed', text: 'Завершено' },
                { value: 'failed', text: 'Ошибка' },
              ],
            },
          ],
        }}
      />
    </TablePageLayout>
  );
}

